import { useCallback, useEffect } from 'react'
import { usePrevious } from 'react-use'
import { useSetAtom } from 'jotai/react'

import { STORAGE_KEY } from '@/constants/common'
import useSolana from '@/lib/solana/hooks/useSolana'
import { services } from '@/stores'

import { TwitterAuthState } from './services/useTwitterAuth'

const useWatcher = () => {
  const { address, isConnected } = useSolana()
  const prevAddress = usePrevious(address)

  const setUserInfo = useSetAtom(services.userInfoAtom)
  const setTwitterAuthStateAtom = useSetAtom(services.twitterAuthStateAtom)

  const reset = useCallback(() => {
    setUserInfo(null)
    setTwitterAuthStateAtom(TwitterAuthState.UN_KNOWN)
  }, [setTwitterAuthStateAtom, setUserInfo])

  useEffect(() => {
    // 切换钱包，清除登录态
    if (prevAddress && address !== prevAddress) reset()
  }, [address, prevAddress, reset])

  useEffect(() => {
    const connectAt = localStorage.getItem(STORAGE_KEY.CONNECT_AT)
    if (isConnected && !connectAt)
      localStorage.setItem(STORAGE_KEY.CONNECT_AT, Date.now().toString())
  }, [isConnected])
}

export default useWatcher
